import React from 'react'
import { icon } from "../functions/icons"
import { StandardComp } from "../atoms/standardComp"
import { HorizontalLayout, VerticalLayout } from "./layout"
import { IconAtom, IconAtom2 } from "../atoms/iconAtom"
import { IconButton } from "../atoms/buttons"
import { margin, padding } from "polished"

export default function StatsObj({ icon2, value, title, BackgroundColor, color }) {
  return (
    <>
    <StandardComp style={{ padding: "1rem", margin: "0", }} content={
        <>
        <HorizontalLayout className="stats-item" style={{ gap: "1rem", alignItems: "center", width: "100%" }}>
            <div className="stats-icon" style={{ backgroundColor: BackgroundColor, borderRadius: "100%", width: "75px", height: "55px", display: "flex", alignItems: "center", justifyContent: "center" }}>{icon(icon2, "30", color)}</div>
            <VerticalLayout style={{ gap: "0.2rem", width: "100%" }}>
                <p className="stats-value bold-text" style={{ fontSize: "1.75rem" }}>{value}</p>
                <p className="stats-title standard-text-color-light">{title}</p>
            </VerticalLayout>
        </HorizontalLayout>
        </>
    } />
    </>
  )
}
